export function silenceAbortErrors() {
    window.addEventListener('unhandledrejection', (event) => {
        const reason = event?.reason;

        if (reason && reason.name === 'AbortError' && reason.message === 'signal is aborted without reason') {
            event.preventDefault();
        }
    });
}
